/**
 * Get language-specific text for the keyboard switch button that returns to the main text keyboard
 * @param languageKey - The language key (e.g., "en-GB", "zh-CN")
 * @returns The appropriate text for the switch button
 */
const getKeyboardSwitchButtonText = (languageKey: string = "en-GB"): string => {
  const languageTextMap: Record<string, string> = {
    "en-GB": "abc",
    "zh-CN": "拼音",
    "hr-HR": "abc",
    "es-PE": "abc",
    "el-GR": "αβγ",
    "ar-SA": "ا‌ب‌ج",
  };

  return languageTextMap[languageKey] || "abc";
};

/**
 * Get language-specific text for the keyboard switch button that switches to the numeric keyboard
 * @param languageKey - The language key (e.g., "en-GB", "zh-CN")
 * @returns The appropriate text for the numeric switch button
 */
const getKeyboardNumericSwitchButtonText = (
  languageKey: string = "en-GB",
): string => {
  const languageTextMap: Record<string, string> = {
    "ar-SA": "١٢٣",
  };

  return languageTextMap[languageKey] || "123";
};

export { getKeyboardSwitchButtonText, getKeyboardNumericSwitchButtonText };
